/**
 * Simpel, forklarbar TCO-model for elbiler i Danmark.
 * Alle satser er input, så brugeren kan se og ændre forudsætningerne.
 */

export interface TcoInput {
  /** Kørte km pr. år */
  kmPerYear: number;
  /** Antal år i beregningen */
  years: number;
  /** Forbrug i Wh/km (WLTP) */
  consumptionWhKm: number;
  /** Andel hjemmeladning 0–1 */
  homeShare: number;
  /** Pris pr. kWh hjemme */
  homePricePerKwh: number;
  /** Pris pr. kWh på offentlig lader */
  publicPricePerKwh: number;
  /** Grøn ejerafgift pr. år */
  annualTaxDkk: number;
  /** Forsikring pr. år */
  insuranceDkk: number;
  /** Service og dæk pr. år */
  serviceDkk: number;
}

export interface TcoResult {
  energyPerYear: number;
  fixedPerYear: number;
  totalPerYear: number;
  totalPeriod: number;
  perKm: number;
  kwhPerYear: number;
}

/** Reelt forbrug ligger typisk 10–15 % over WLTP inkl. ladetab. */
export const REAL_WORLD_UPLIFT = 1.12;

export function calcTco(input: TcoInput): TcoResult {
  const {
    kmPerYear,
    years,
    consumptionWhKm,
    homeShare,
    homePricePerKwh,
    publicPricePerKwh,
    annualTaxDkk,
    insuranceDkk,
    serviceDkk,
  } = input;

  const kwhPerYear = (kmPerYear * consumptionWhKm * REAL_WORLD_UPLIFT) / 1000;
  const share = Math.min(1, Math.max(0, homeShare));
  const energyPerYear =
    kwhPerYear * (share * homePricePerKwh + (1 - share) * publicPricePerKwh);
  const fixedPerYear = annualTaxDkk + insuranceDkk + serviceDkk;
  const totalPerYear = energyPerYear + fixedPerYear;

  return {
    energyPerYear: Math.round(energyPerYear),
    fixedPerYear: Math.round(fixedPerYear),
    totalPerYear: Math.round(totalPerYear),
    totalPeriod: Math.round(totalPerYear * years),
    perKm: Math.round((totalPerYear / Math.max(1, kmPerYear)) * 100) / 100,
    kwhPerYear: Math.round(kwhPerYear),
  };
}
